<template>
  <span>
    <div ref="container" v-html="content" />
  </span>
</template>

<script>
import lodashGet from "lodash/get";
import { mapGetters } from "vuex";
import { MODULE_PREFIX_HOME } from "@/store";
import { EVENT_ACTIONS, EVENT_CATEGORIES } from "@/common/constants/analytics";

const EMITTED_ACTIONS = {
  AFTER_CLICK: "after-click",
};

export default {
  name: "DetailsListItemClickable",
  props: {
    content: {
      type: String,
    },
    analyticsCategory: {
      type: String,
      required: false,
      default: EVENT_CATEGORIES.country_link,
    },
  },
  computed: {
    ...mapGetters({
      selectorPanel: MODULE_PREFIX_HOME + "selectorPanel",
    }),
  },
  methods: {
    async handleClick(evt) {
      evt.preventDefault();

      let country = lodashGet(
        evt,
        "srcElement.attributes.data-country-name.nodeValue"
      );

      this.selectorPanel.selected = "stability";
      this.selectorPanel.visible = true;
      this.selectorPanel.selectedData = country;

      if (this.analyticsCategory) {
        this.handlePageTrackerEvent(
          this.analyticsCategory,
          EVENT_ACTIONS.clicked,
          `${country}`
        );
      }

      this.$emit(EMITTED_ACTIONS.AFTER_CLICK);
    },
  },
  watch: {
    content: {
      async handler() {
        await this.$nextTick();
        this.$refs.container.querySelectorAll("a").forEach((input) => {
          input.addEventListener("click", this.handleClick);
        });
      },
      immediate: true,
    },
  },
};
</script>
